module.exports = __webpack_public_path__ + "static/media/aboutus-img.0feb48f8.png";